import { createAction, props } from '@ngrx/store';
import { Product } from 'graphql-api/gql-api-interfaces';
import { Media, ProductReference } from '@epicuro-next/models/engagement';

export const loadEpicShowProducts = createAction(
  '[Product List] Load Epic Show products',
  props<{ ids: string[] }>(),
);

export const loadEpicShowProductsSuccess = createAction(
  '[ProductList] Load Epic Show products in opened List Success',
  props<{ products: Product[] }>(),
);

export const upsertEpicShowProductsReferences = createAction(
  '[ProductList] Upsert Epic Show Products References',
  props<{ references: ProductReference[] }>(),
);

export const updateEpicShowProductsAvailability = createAction(
  '[ProductList] Update Epic Show Products Availability',
  props<{ products: Product[] }>(),
);

export const createEpicShow = createAction(
  '[Product List] Create Epic Show',
  props<{ media: Media }>(),
);

export const createEpicShowSuccess = createAction(
  '[Product List] Create Epic Show Success',
  props<{ media: Media }>(),
);

export const createEpicShowFail = createAction(
  '[Product List] Create Epic Show Fail',
);

export const removeEpicShow = createAction('[Product List] Remove Epic Show');

export const removeEpicShowSuccess = createAction(
  '[Product List] Remove Epic Show Success',
  props<{ media: Media }>(),
);

export const removeEpicShowFail = createAction(
  '[Product List] Remove Epic Show Fail',
);

export const patchEpicShowProductInList = createAction(
  '[Product List] Patch epic show product in list',
  props<{ product: Product }>(),
);
